import { Button } from '@cluey/cluey-components/dist/components/atoms/Button/Button';
import { Container } from '@cluey/cluey-components/dist/components/atoms/Container/Container';
import classNames from 'classnames';
import moment from 'moment';
import { useContext } from 'react';
import { useHistory } from 'react-router';

import { CheckIcon } from '../../../../../icons';
import { PATH_HUB_SESSIONS_PAGE } from '../../../../../util/pagePath';
import { TRACKING_PE } from '../../../../../util/trackingClasses';
import { Session } from '../../../../legacy/types';
import { PauseEnrolmentContext } from '../../../pause-enrolment/PauseEnrolmentContext';

export type SummerPauseAndDiscountSuccessProps = {
  upcomingSessions: Session[] | undefined;
};

const SummerPauseAndDiscountSuccess = () => {
  const history = useHistory();
  const { selectedEnrolment, pauseStartDate, resumptionDate } = useContext(PauseEnrolmentContext);

  const { student, subject } = selectedEnrolment;

  return (
    <Container className="flex flex-col items-center gap-9 px-4 py-7 md:py-8 lg:mb-0">
      <div
        className={classNames('mt-10 flex flex-col items-center gap-2', {
          [TRACKING_PE.SUCCESS]: TRACKING_PE.SUCCESS,
        })}
      >
        <div className="flex h-[60px] w-[60px] items-center justify-center rounded-full bg-green-4">
          <CheckIcon className="text-white" width={40} height={40} />
        </div>
        <h1 className="text-center font-display text-[32px] font-bold sm:text-[40px]">Pause request sent</h1>
      </div>
      <div className="flex flex-col items-center gap-4 text-lg">
        <p>{`Your request to pause ${student}'s ${subject} enrolment has been sent.`}</p>
        <p>
          {`Sessions will be paused from ${moment(pauseStartDate).format('dddd, D MMMM YYYY')} and resume on ${moment(
            resumptionDate
          ).format('dddd, D MMMM YYYY')}`}
        </p>
      </div>
      <div className="text-center text-lg">
        <p className="mb-4">A 20% discount will be applied to the first 5 unpaid sessions after resumption</p>
        <p className="mt-4">Discounted sessions will be reflected in the session details</p>
      </div>
      <Button
        onClick={() => {
          history.push(PATH_HUB_SESSIONS_PAGE);
        }}
        size="lg"
        appearance="reverse"
      >
        View sessions
      </Button>
      <div className="h-[150px]" />
    </Container>
  );
};

export default SummerPauseAndDiscountSuccess;
